module.exports = __webpack_public_path__ + "img/comparison_special-access.b281db27.jpg";